<template>
  <div class="modal-box">
    <div class="loading-box" v-if="isLoading">
      <loading></loading>
    </div>
    <div class="modal invalidate-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ isRestore ? 'チケットの無効化を取り消します' : 'チケットを無効にします' }}</h4>
          </div>
          <div class="modal-body">
            <template v-if="isRestore">
              <div class="invalidate-section">
                <p>チケットの無効化を取り消します。</p>
                <p>対象のチケットは使用可能になります。</p>
                <p>販売期間中の場合は、再び有効にする枚数分が販売可能数から差し引かれます。</p>
              </div>
            </template>
            <template v-else>
              <div class="invalidate-section">
                <p>無効にしたチケットは使用できなくなります。</p>
                <p>払い戻しは行われません。</p>
              </div>
              <div class="invalidate-section">
                <p>チケットを無効にした際、購入者へ通知は送信されません。</p>
                <p>無効化はあとから取り消すことができます。</p>
              </div>
              <div class="invalidate-section" v-if="audience.is_divide_percial">
                <p>※対象のチケットは分配されています。実行すると分配先のチケットも使用できなくなります。</p>
              </div>
              <div class="invalidate-section" v-if="audience.is_request_resaling">
                <p>※対象のチケットはリセールに出品されています。実行すると出品は取り下げられます。</p>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="execute">{{ isRestore ? '無効化を取り消す' : 'チケットを無効にする' }}</button>
            <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audience: { type: Object, required: true },
    // 無効化と取り消しは確認文と呼び出し先だけが異なるため同じコンポーネントで扱う
    isRestore: { type: Boolean, required: true },
    edit_audience_path: { type: String, required: true },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async execute() {
      this.isLoading = true;
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      try {
        if (this.isRestore) {
          await this.$store.dispatch('audience/restoreAudience', {
            restore_audience_path: this.edit_audience_path,
            csrf_token: csrfToken,
            audience_id: this.audience.id,
          });
          alert(this.audience.name + '様のチケットの無効化を取り消しました。');
        } else {
          await this.$store.dispatch('audience/invalidateAudience', {
            invalidate_audience_path: this.edit_audience_path,
            csrf_token: csrfToken,
            audience_id: this.audience.id,
          });
          alert(this.audience.name + '様のチケットを無効化しました。');
        }
        this.$emit('close-btn-click');
      } catch (error) {
        // 失敗時はモーダルを開いたままにして再試行できるようにする
        alert('エラーが発生しました。時間をおいてから改めてお試しください。');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .invalidate-modal {
    display: flex;
    overflow-y: auto;

    .modal-title {
      font-size: 18px;
    }

    .modal-dialog {
      max-width: 100%;
      width: 700px;
      margin: auto;

      @media screen and (max-width: $break-point) {
        margin: auto 30px;
      }
    }

    .modal-body {
      padding: 15px;
      line-height: 1.5em;
      margin-bottom: 15px;

      p {
        margin-bottom: 10px;
      }

      .invalidate-section + .invalidate-section {
        margin-top: 20px;
      }
    }

    .modal-content {
      box-shadow: none;
      z-index: 9997;
    }

    .modal-footer {
      display: flex;
      justify-content: center;
      gap: 10px;
    }
  }

  .loading-box {
    background-color: #000;
    opacity: 0.8;
    z-index: 1051;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
